import {History} from '../../../graphql-typings/graphql';
import {SimpleFunction} from './simple-function';
import {FunctionName} from './chart-function-types';

export class AbsFunction extends SimpleFunction {

  constructor() {
    super(FunctionName.ABS, 'Absolute');
  }

  run(historyArray: History[]): History[] {
    return super.applySimpleFunction(Math.abs, historyArray);
  }
}
